module.exports = __webpack_public_path__ + "img/pdxq.943a47d6.png";